// ** react import
import React from 'react';

// ** calendly import
import { InlineWidget } from 'react-calendly';

// ** context import
import { useThemeProvider } from '../../contexts/ThemeContext';

const Appointment = () => {
  const { currentTheme } = useThemeProvider();
  const backgroundColor = currentTheme === 'dark' ? '1b2228' : 'ffffff';
  const textColor = currentTheme === 'dark' ? 'd9e0e6' : '1a202c';
  const primaryColor = '5f95be';

  console.log(process.env.CALENDLY_URL, process.env.NODE_ENV)

  return (
    <div className="bg-white dark:bg-gray-700">
      <InlineWidget
        key={currentTheme}
        url={process.env.CALENDLY_URL}
        pageSettings={{
          backgroundColor: backgroundColor,
          textColor,
          primaryColor,
          hideEventTypeDetails: false,
          hideLandingPageDetails: true,
          theme: currentTheme === 'dark' ? 'dark' : 'light',
        }}
        styles={{
          height: '100vh',
          width: '100vw',
          backgroundColor: backgroundColor,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -45%)',
        }}
      />
    </div>
  );
};

export default Appointment;
